import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 text-sm leading-relaxed text-ivory/60 max-w-xs">
            Implantologia avanzata, protesi e ortodonzia invisibile con la tecnologia di una clinica e
            l'attenzione di uno studio di famiglia.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-teal mb-5">Contatti</p>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li>
              <a href="tel:01119667070" data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-teal transition-colors">
                <Phone size={15} className="text-teal" /> 011 19667070
              </a>
            </li>
            <li>
              <a href="mailto:info@dentalchivasso.it" data-testid="footer-email-link" className="flex items-center gap-3 hover:text-teal transition-colors">
                <Mail size={15} className="text-teal" /> info@dentalchivasso.it
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={15} className="text-teal mt-0.5 shrink-0" />
              <span>Via Gerbido 15/3, 10034 Chivasso (TO)</span>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-teal mb-5">Esplora</p>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li><Link to="/servizi" data-testid="footer-link-servizi" className="hover:text-teal transition-colors">Servizi</Link></li>
            <li><Link to="/prima-e-dopo" data-testid="footer-link-prima-dopo" className="hover:text-teal transition-colors">Prima e dopo</Link></li>
            <li><Link to="/prezzi" data-testid="footer-link-prezzi" className="hover:text-teal transition-colors">Prezzi</Link></li>
            <li><Link to="/studio" data-testid="footer-link-studio" className="hover:text-teal transition-colors">Il nostro staff</Link></li>
            <li><Link to="/contatti" data-testid="footer-link-contatti" className="hover:text-teal transition-colors">Prenota una visita</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ivory/45">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Dentalchivasso — Studio Dentistico, Chivasso (TO)</p>
          <p>A 700m dalla Stazione FS di Chivasso · Parcheggio per i pazienti</p>
        </div>
        <div className="max-w-7xl mx-auto px-5 md:px-8 pb-6 text-center text-xs text-ivory/45" data-testid="footer-direttore">
          Direttore Sanitario: Dr.ssa Olesja Pucinska · Odontoiatra iscritta all'albo di Varese
        </div>
      </div>
    </footer>
  );
}